import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { ReactNode } from 'react';

export interface ToastsProps {
  msg: string;
  timeStamp: number;
  icon?: ReactNode;
  button?: {
    tk: string;
    onClick: () => void;
  };
  msgDynamicValues?: string[];
}

const initialState: { toasts: ToastsProps[] } = {
  toasts: [],
};

export const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    createToast: (state, action: PayloadAction<string>) => {
      state.toasts = [...state.toasts, { msg: action.payload, timeStamp: Date.now() }];

      if (state.toasts.length > 3) {
        toastSlice.caseReducers.removeToast(state, { payload: state.toasts[0].timeStamp, type: 'toast-remove' });
      }
    },
    removeToast: (state, action: PayloadAction<number>) => {
      state.toasts = state.toasts.filter((toast) => toast.timeStamp !== action.payload);
    },
  },
});

export const toastActions = toastSlice.actions;
